module.exports = __webpack_public_path__ + "static/media/dropdown-icon-down.59dcafd1.svg";